import { Loading } from '@affine/component';
import { Trans } from '@affine/i18n';
import { cn } from '@udecode/cn';
import type { CSSProperties } from 'react';

import type { PageListItemProps } from '../types';

type DocWikiStatusProps = Pick<PageListItemProps, 'status'> & {
  style?: CSSProperties;
  className?: string;
};

export const DocWikiStatus = ({
  status,
  style,
  className,
}: DocWikiStatusProps) => {
  const translateStatusKey = status
    ? `docnboard.wiki.status.${status.toLowerCase()}`
    : undefined;
  return (
    <div
      data-testid="page-list-item-status"
      className={cn('flex gap-1 items-center', className)}
      style={style}
    >
      {['Publishing', 'Deleting'].includes(status ?? '') && <Loading />}
      <Trans i18nKey={translateStatusKey} />
    </div>
  );
};
